let callbacks: Array< () => void > = [];
let isComplete = false;
let timeoutId: number | null = null;

function runCallbacks(): void {
	if ( isComplete ) {
		return;
	}

	clearTimeout();
	document.removeEventListener( 'readystatechange', onReadyStateChange );

	callbacks.forEach( ( callback ) => callback() );
	callbacks = [];
	isComplete = true;
}

function clearTimeout(): void {
	if ( timeoutId !== null ) {
		window.clearTimeout( timeoutId );
		timeoutId = null;
	}
}

function onReadyStateChange(): void {
	if ( document.readyState === 'complete' ) {
		runCallbacks();
	} else if ( document.readyState === 'interactive' && ! timeoutId ) {
		timeoutId = window.setTimeout( runCallbacks, 5000 );
	}
}

onReadyStateChange();

document.addEventListener( 'readystatechange', onReadyStateChange );

export function documentReady( callback: () => void ): void {
	if ( isComplete ) {
		callback();
	} else {
		callbacks.push( callback );
	}
}
